const ROUTES = {
  // User / courier
  home: () => '/home',
  storage: () => '/storage',
  dev: () => '/dev',
  request: () => '/request',
  messages: () => '/messages',
  history: () => '/history',
  market: () => '/market',
  myItems: () => '/my-items',
  marketSearch: () => '/market-search',
  profile: () => '/profile',
  myStorages: () => '/my-storages',
  requestStorage: () => '/request-storage',
  requestReturn: () => '/request-return',
  subscription: () => '/subscription',
  subscriptionPackage: () => '/subscription-package',
  subscriptionSuccess: () => '/subscription-success',
  mySubscription: () => '/my-subscription',
  address: () => '/address',
  sellProduct: () => '/sell-product',
  sellMultiProduct: () => '/sell-multi-product',
  requestItem: () => '/request-item',
  notifications: () => '/notifications',
  wallet: () => '/wallet',
  cart: () => '/cart',
  extraStorage: () => '/extra-storage',
  extraStorageConfirm: () => '/extra-storage-confirm',
  about: () => '/oenobank/about',
  privacyPolicy: () => '/oenobank/privacy-policy',
  termsConditions: () => '/oenobank/terms',
  helpCenter: () => '/oenobank/help',
  contactUs: () => '/contact-us',
  settings: () => '/settings',

  // Admin
  requestIn: () => '/request-in',
  requestOut: () => '/request-out',
  couriers: () => '/couriers',
  admins: () => '/admins',
  customers: () => '/customers',
  transactions: () => '/transactions',
  overview: () => '/overview',

  // Auth
  signin: () => '/signin',
  signup: () => '/signup',
  signupConfirmation: () => '/signup-confirmation',
  forgotPassword: () => '/forgot-password',
  createNewPass: () => '/create-new-password',
  resetPassConfirmation: () => '/reset-password-confirm',
  resetPassSuccess: () => '/reset-password-success',
  otp: () => '/otp',
  signupVerif: () => '/signup-verif',
  purchase: () => '/purchase-confirmation',
  lang: () => '/language',
};

export default ROUTES;
